import { useMediaQuery } from "@mui/material";

/**
 * Returns true if the site is rendered in a PWA application.
 */
export const useIsInsidePwa = () => useMediaQuery("(display-mode: standalone)");
